import React from 'react';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import MuiFormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiFormHelperText from '@material-ui/core/FormHelperText';
import MuiTextField from '@material-ui/core/TextField';
import MuiInputAdornment from '@material-ui/core/InputAdornment';
import MuiGrid from '@material-ui/core/Grid';
import MuiBox from '@material-ui/core/Box';

const styles = () => ({
  bold: {
    fontWeight: 'bold',
  },
  formElement: {
    margin: '6px',
    padding: '6px',
    width: '100%',
  },
});

function AccountDetails({ ...props }) {
  const { classes, updateForm, formData, payees, account } = props;

  return (
    <MuiGrid container>
      <MuiGrid item xs={3}>
        <span className={classes.bold}>Add Account Details</span>
        <p>
          Add the details of the recoupment account. <br />
          These details can be edited later
        </p>
      </MuiGrid>
      <MuiGrid item xs={6}>
        {!account && (
          <MuiBox>
            <MuiFormControl className={classes.formElement}>
              <MuiFormHelperText>Label</MuiFormHelperText>
              <>
                {payees ? (
                  <MuiSelect
                    labelId="select-payee"
                    id="user_group_id"
                    value={formData.user_group_id || ''}
                    onChange={evt =>
                      updateForm({
                        target: { ...evt.target, id: 'user_group_id' },
                      })
                    }>
                    <MuiMenuItem value={0}> -- Please Select A Label -- </MuiMenuItem>
                    {payees.map((payee, i) => (
                      <MuiMenuItem key={i} value={payee.user_group_id}>
                        {payee.name}
                      </MuiMenuItem>
                    ))}
                  </MuiSelect>
                ) : (
                  <MuiCircularProgress />
                )}
              </>
            </MuiFormControl>
          </MuiBox>
        )}
        <MuiBox>
          <MuiFormControl className={classes.formElement}>
            <MuiFormHelperText>Account Name</MuiFormHelperText>
            <MuiTextField id="name" onChange={updateForm} value={formData.name || ''} />
          </MuiFormControl>
        </MuiBox>
        <MuiBox>
          <MuiFormControl className={classes.formElement}>
            <MuiFormHelperText>Total Committed</MuiFormHelperText>
            <MuiTextField
              id="committed_usd"
              onChange={updateForm}
              type="number"
              InputProps={{
                startAdornment: <MuiInputAdornment position="start">$</MuiInputAdornment>,
              }}
              value={formData.committed_usd || 0}
            />
          </MuiFormControl>
        </MuiBox>
        {!account && (
          <MuiBox>
            <MuiFormControl className={classes.formElement}>
              <MuiFormHelperText>Effective Date</MuiFormHelperText>
              <input
                type="date"
                id="open_date"
                onChange={updateForm}
                value={formData.open_date ? new Date(formData.open_date).toISOString().split('T')[0] : ''}
              />
            </MuiFormControl>
          </MuiBox>
        )}
      </MuiGrid>
    </MuiGrid>
  );
}

export default withStyles(styles)(AccountDetails);
